// angular
// 	.module("HeroPRO")
// 	.controller("TrainingController", trainingController);

import _ from 'lodash';
import './trainingContent.scss';

/* @ngInject */
export default function trainingController(TrainingFactory, UserData, HPActionItemUrls, $rootScope, $document) {
    const vm = this;
    let trainingModule = null;
    vm.currentTopic = null;
    vm.prevTopic = null;
    vm.totalSlides = null;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.next = function () {
        const next = _.find(trainingModule.Topics, t => t.TemplateName === vm.currentTopic.next);
        
        if (next) {
            next.IsCurrent = true;
            vm.currentTopic.IsCurrent = !next.IsCurrent;
            vm.prevTopic = vm.currentTopic;
            vm.currentTopic = next;

            if (typeof next.onEnter === 'function') {
                next.onEnter().then(() => {
                    $rootScope.$broadcast('notificationCompleted');
                }, (error) => {
                    if (error.status === 500) {
                        $rootScope.$broadcast('HPErrorServer');
                    } else {
                        $rootScope.$broadcast('HPErrorUnknown');
                    }
                });
            }
        }

        scrollToTop();
    };

    vm.getCurrentSlideNumber = function() {
        for(var i = 0; i < trainingModule.Topics.length; i++) {
            var mod = trainingModule.Topics[i];

            if(mod.IsCurrent)
                return i;
        }

        return -1;
    }

    vm.prev = function () {
        const prev = _.find(trainingModule.Topics, t => t.TemplateName === vm.currentTopic.prev);
        if (prev) {
            prev.IsCurrent = true;
            vm.currentTopic.IsCurrent = !prev.IsCurrent;
            vm.prevTopic = vm.currentTopic;
            vm.currentTopic = prev;
        }

        scrollToTop();
    };

    vm.complete = function () {
        TrainingFactory.complete().then(() => {
            vm.currentTopic.templateUrl = HPActionItemUrls.Completed;
            $rootScope.$broadcast('notificationCompleted');
        }, (error) => {
            $rootScope.$broadcast('closeNotificationModal', { result: false, errorStatus: error.status });
        });

        scrollToTop();
    };

    vm.scrollToTop = function () {
        scrollToTop();
    };


    /*= ========================================
	 =            Private Functions            =
	 ========================================= */
    function init() {
        TrainingFactory.getContractorType(UserData.getUserLocations()).then((type) => {
            TrainingFactory.getPages(type).then((response) => {
                trainingModule = response;
                vm.totalSlides = trainingModule.Topics.length - 2;
                vm.currentTopic = _.find(response.Topics, r => r.IsCurrent === true);
            });
        });
    }

    function scrollToTop() {
        angular.element($document[0].querySelector('.modal-content'))[0].scrollTop = 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/training/trainingController.js